var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetailSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114.7 114.7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.4 8.5H22.3c-3.8 0-7.1 2.8-7.7 6.6l-1.8 10.8h89.1l-1.8-10.8c-.6-3.8-3.9-6.6-7.7-6.6zM5.9 30c0 8.6 7 15.6 15.6 15.6 4.8 0 9.1-2.2 12-5.6 2.9 3.4 7.2 5.6 12 5.6s9.1-2.2 12-5.6c2.9 3.4 7.2 5.6 12 5.6s9.1-2.2 12-5.6c2.9 3.4 7.2 5.6 12 5.6 8.6 0 15.6-7 15.6-15.6H5.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66.2,
    cy: 64.9,
    r: 2.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 99.4H48.9c-5 0-9.1 4.1-9.1 9.1h33.7c0-5-4-9.1-9-9.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.5 71.5V45.4c-1.2 1-2.6 1.8-4.1 2.5v20.8H75.6v-20c-1.3.4-2.7.7-4 .9v41.7H55.4c-6.7 0-12.2-5.5-12.2-12.2V49.6c-1.4-.2-2.8-.5-4.1-.9v19.8H13.2V47.9c-1.5-.7-2.8-1.5-4.1-2.5v53.8c0 1.5 1.2 2.6 2.6 2.6h25.9c2.3-3.8 6.5-6.4 11.3-6.4h15.5c4.8 0 9 2.6 11.3 6.4h27.2c1.5 0 2.6-1.2 2.6-2.6V71.5z"
  })));
}
export default SvgRetailSquare;